<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ 'components.footer.sponsorsShort' | translate }}
    </h4>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body map-modal-body">
    <img class="bottom-image" src="assets/images/FINANSE-ES+NEXT+NAP_BLACK.svg" alt="sponsors" />
  </div>
</ng-template>

<a class="open-button" (keydown.enter)="open(content)" (click)="open(content)" tabindex="0">
  {{ 'components.footer.sponsors' | translate }}
</a>
